import { LABELS } from "~/resources/Labels";
import { TableHeaderType } from "../types/TableHeaderType";

export const CloudProvisionerHeader: TableHeaderType[] = [
    {
      label: 'ID',
      key: 'id',
      id: 'id',
      sortable: true,
    },
    {
      label:'Project ID',
      key: 'projectId',
      id: 'projectId',
      sortable: false,
    },
    {
      label:'File Name',
      key: 'fileName',
      id: 'fileName',
      sortable: true,
    },
    {
      id: 'flavor',
      label: LABELS.Flavor,
      sortable: false,
      key: 'flavor',
    },
    {
      id: 'providerType',
      label: LABELS.ProviderType,
      sortable: true,
      key: 'providerType',
    },
  ];
